import React from 'react';
import { RecommenderLogsResponse } from '../Types';

type TModelItemProps = {
    handleSelectItemChange: (item: RecommenderLogsResponse) => void;
    model: RecommenderLogsResponse;
}

const ModelItem = ({model, handleSelectItemChange}: TModelItemProps) => {
    return (
        <div className="tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-[#ebecf0] tw-flex tw-justify-between tw-items-center tw-mx-6 tw-my-3">
            <label className=" tw-text-[#172B4D] tw-text-sm">{model?.model_name}</label>
            <button data-testid="components-modelitem-button-1" onClick={() => {handleSelectItemChange(model)}} className="tw-text-right tw-text-[#bf2600] tw-text-xs">Remove</button>
        </div>
    );
}

export default ModelItem;